import type React from 'react';

import { TabList, Tabs } from '@change/ds-core-ui/Tabs';

import { usePageTabs } from './hooks/usePageTabs';

export const PageTabs: React.FC<EmptyProps> = () => {
	const {
		data: { activeTab, items },
	} = usePageTabs();

	return (
		<Tabs className="scrollbar-hide overflow-x-auto" selectedKey={activeTab} data-qa="tab-links">
			<TabList items={items} />
		</Tabs>
	);
};
